import Cookies from 'vue-cookies'

const TokenKey = 'Admin-Token'

export function getToken() {
  return localStorage.getItem('token')
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  sessionStorage.clear()
  return Cookies.remove('PHPSESSID')
}
